"use client";
import React from "react";
import Image from "next/image";
import { Typography } from "@material-tailwind/react";
import {
  AcademicCapIcon,
  CheckBadgeIcon,
  EyeIcon,
  InboxIcon,
} from "@heroicons/react/24/solid";

import FeatureCard from "@/components/feature-card";
import Card from "@material-tailwind/react/components/Card";
import { CheckIcon } from "@heroicons/react/24/outline";

const FEATURES = [
  {
    icon: CheckIcon,
    title: "Mission",
    description:
      "To empower caregivers with comprehensive training and support, and to provide compassionate and specialized care to elderly individuals, enhancing their quality of life and promoting their well-being.",
  },
  {
    icon: EyeIcon,
    title: "Vision",
    description:
      "We aim to establish a one-of-a-kind care home dedicated to providing exceptional care for seniors with various age-related challenges, setting the standard for eldercare in Nepal.",
  },
  {
    icon: CheckBadgeIcon,
    title: "Objectives",
    description: "Provide comprehensive caregiver training packages covering levels 1 to 5, ensuring that trainees are equipped with the necessary skills and knowledge to deliver exceptional care to elderly individuals",
  },
];

export function OurGoals() {

  
  return (
    <section className="py-28 px-8 bg-gray-100">
      <div className="container mx-auto grid grid-cols-1 place-items-center lg:grid-cols-3 animate-fade duration-500">
   
        <div className="col-span-3 lg:pl-24  ">
          <Typography variant="h2" color="black" className="mb-4 animate-fade duration-500 text-center"  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} >
          Our Future Goals
          </Typography>
          <Typography
            variant="h6"
            className="mb-4  px-3 text-left text-lg !text-black-500 font-normal lg:px-0 animate-fade text-center duration-500 "  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}          >
            Looking towards the future, our vision extends beyond training and guidance. We aspire to establish a one-of-a-kind care home on the outskirts of a prominent city in Nepal, dedicated to providing compassionate and specialized care for elderly individuals facing various age-related challenges. This facility will be a sanctuary where residents receive not only the physical care they need but also the emotional support and companionship that are essential for their well-being.
          </Typography>
          

          <div className="col-span-2 grid grid-cols-1 gap-10 sm:grid-cols-3 animate-fade duration-500 mt-10">
            {FEATURES.map(({ icon, title, description },id) => (
               <Card key={id} className="px-6 pb-5 hover:bg-teal-100 cursor-pointer animate-fade duration-500"  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            
              <FeatureCard key={title} icon={icon} title={title}>
                {description}
              </FeatureCard>
          
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurGoals;
